import IncidentReport from "../fragments/incidentReport";

export default `
query GetIncidentReport($incidentId: ID!) {
  getIncidentReport(incidentId: $incidentId) ${IncidentReport}
}
`;
